/**
 * CDN helpers for S3-backed media (CloudFront Phase 1).
 */

const CDN_DOMAIN = (process.env.REACT_APP_CLOUDFRONT_DOMAIN || '')
  .replace(/^https?:\/\//, '')
  .replace(/\/$/, '');

const S3_BUCKET = process.env.REACT_APP_S3_BUCKET_NAME;
const AWS_REGION = process.env.REACT_APP_AWS_REGION || 'us-east-1';

export const CACHE_CONTROL_IMMUTABLE = 'public, max-age=31536000, immutable';

export function getCdnDomain() {
  return CDN_DOMAIN || null;
}

export function getS3PublicUrl(s3Key) {
  if (!s3Key || !S3_BUCKET) return null;
  return `https://${S3_BUCKET}.s3.${AWS_REGION}.amazonaws.com/${s3Key}`;
}

export function getCdnUrl(s3Key) {
  if (!s3Key) return null;
  return CDN_DOMAIN
    ? `https://${CDN_DOMAIN}/${s3Key}`
    : getS3PublicUrl(s3Key);
}

/**
 * Rewrite a stored S3 URL to the CDN domain when REACT_APP_CLOUDFRONT_DOMAIN is set.
 */
export function normalizeImageUrl(url) {
  if (!url || typeof url !== 'string') return url;
  if (!CDN_DOMAIN || !S3_BUCKET) return url;

  const bucketHost = `${S3_BUCKET}.s3.`;
  if (!url.includes(bucketHost)) return url;

  try {
    const parsed = new URL(url);
    if (!parsed.hostname.startsWith(bucketHost)) return url;
    parsed.hostname = CDN_DOMAIN;
    return parsed.toString();
  } catch {
    return url.replace(
      new RegExp(`https://${S3_BUCKET}\\.s3\\.[^/]+\\.amazonaws\\.com`),
      `https://${CDN_DOMAIN}`
    );
  }
}
